import React, { Fragment } from "react";
import Header from "../shared/general/Header";
import CreatePasswordForm from "./CreatePasswordForm";
import Footer from "../shared/general/Footer";

const EmployerCreatePassword = (props) => (
  <Fragment>
    <Header />
    <CreatePasswordForm {...props} />
    <Footer positionAbsolute />
  </Fragment>
);

export default EmployerCreatePassword;
